import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getWaterfallGroupHeaderStyles } from '../../../styles/waterfall-group-header-styles';

const WaterfallGroupHeader = ({
  headerText,
  classes,
}) => {
  const headerClasses = classNames('waterfall-list-header', classes.header);

  return (
    <div className={headerClasses}>
      <span>
        {headerText}
      </span>
    </div>
  );
};

WaterfallGroupHeader.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getWaterfallGroupHeaderStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  headerText: PropTypes.string.isRequired,
};

export const StyledWaterfallGroupHeader =
  withDefaultStyles(WaterfallGroupHeader, getWaterfallGroupHeaderStyles);
